export const baseUrl = "https://chatsphere-api.onrender.com/api/v1"
